import { useMemo } from "react";
import { Colors, Spacings, View } from "react-native-ui-lib";
import { Item } from "./components";
import { CIRCLE_DIAMETER } from "./constants";

export type ColorPickerProps = {
  defaultValue?: string;
  value?: string;
  hexList: string[];
  onChange: (colors: string) => void;
};

export function ColorPicker({
  defaultValue,
  value,
  hexList,
  onChange,
}: ColorPickerProps) {
  const filteredHexList = useMemo(
    () => hexList.filter((hex) => hex !== defaultValue),
    [defaultValue, hexList]
  );

  const colorsMarkup = filteredHexList.map((hexCode, i) => {
    const selected = hexCode === value;
    return (
      <Item
        key={i}
        hexCode={hexCode}
        selected={selected}
        onPress={() => onChange(hexCode)}
      />
    );
  });

  const defaultItemMarkup = defaultValue ? (
    <>
      <Item
        hexCode={defaultValue}
        selected={defaultValue === value}
        onPress={() => onChange(defaultValue)}
      />
      <View
        style={{
          display: "flex",
          paddingLeft: Spacings.s1 / 2,
          margin: Spacings.s1,
          marginRight: Spacings.s1 * 2,
          height: CIRCLE_DIAMETER,
          borderRightWidth: 2,
          borderColor: Colors.borderColor,
        }}
      />
    </>
  ) : null;

  return (
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      {defaultItemMarkup}
      {colorsMarkup}
    </View>
  );
}

ColorPicker.Item = Item;
